// The event videos page narrowed to one participant (`?uid=`, linked from the
// user page). Filtered in the browser: the page already holds every video of
// the event in one live listener, so this needs no query and no index.

/**
 * @param {Array<{uid: string}>} videos
 * @param {?string} uid The owner asked for; empty means everyone.
 * @returns {Array} The same array when unfiltered.
 */
export function videosByOwner(videos, uid) {
  if (!uid) return videos
  return videos.filter((v) => v.uid === uid)
}

/**
 * What to call the owner: the first name any of their videos was sent under
 * (`userName`, typed in the webapp), else the uid.
 * @param {Array<{userName: ?string}>} videos Their videos.
 * @param {string} uid
 * @returns {string}
 */
export function ownerLabel(videos, uid) {
  return videos.find((v) => v.userName)?.userName || uid
}
